import React from 'react';
import { useSelector } from 'react-redux';
import PlotContainer from '../PlotContainer';
import BoxMetrics from '../BoxMetrics';
import { useGetArchiveOutreachGraphQuery } from '../../redux/api/archiveInfluencer';;

const InfluencerOutreachPage = () => {

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedStartDate = useSelector((state) => state.genericReporting.selectedDropdownValues['start_date']);
    const selectedEndDate = useSelector((state) => state.genericReporting.selectedDropdownValues['end_date']);
    const selectedDateGranularity = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const rollingWindow = useSelector((state) => state.genericReporting.rollingWindow);
    const isRolling = useSelector((state) => state.genericReporting.IsRolling);

    return (
        <div>
            <BoxMetrics suffixStr='/influencer_outreach'></BoxMetrics>
            <div className='full-width-container'>
                <PlotContainer useApi={useGetArchiveOutreachGraphQuery} tooltipTitle='Total Spend vs 7D Rolling Total Spend' useApiArgs={{
                    client: selectedClient,
                    startDate: selectedStartDate,
                    endDate: selectedEndDate,
                    granularity: selectedDateGranularity,
                    rollingWindow: rollingWindow,
                    isRolling: isRolling,
                }} />
            </div>
        </div>
    );
};

export default InfluencerOutreachPage